<template>
<base-popup
    :popup-model="show"
    :title="`Manual Payment - ${currentItem.mergedNo}`"
    :valid="!valid"
    @onSaveButtonClick="manualPaymentHandler"
    @onCancelButtonClick="closePopupHandler"
>
  <v-form
      :ref="formRef"
      v-model="valid"
      lazy-validation
  >
    <v-row class="mt-8 mb-3 mr-3">
      <v-col cols="12" class="mt-0 mb-0 ml-0 pt-0 pb-0 pl-0">
        <div class="text-lg-subtitle-1" style="justify-content: center !important;"><p>This is the Payment of Invoice No: {{getInvoiceNo()}}</p></div>
      </v-col>
      <v-col cols="12" class="mt-0 mb-0 ml-0 pt-0 pb-0 pl-0">
        <g-p-auto-complete
            :dense="true"
            :outlined="true"
            icon="mdi-contacts"
            search-label="Select Method"
            :search-value="currentItem.paymentMethod"
            :status=true
            :validation="true"
            @selectSearchResult="onSelections('paymentMethod',$event)"
            @clearSearchResult="handleClearSearchResult('paymentMethod')"
            apiPath="method/get-all-by-type"
        />
      </v-col>
      <v-col cols="12" class="mt-0 mb-0 ml-0 pt-0 pb-0 pl-0">
        <v-text-field
            label="Transaction No."
            prepend-icon="mdi-cog-transfer"
            v-model="currentItem.trxnId"
            dense
            outlined
        />
      </v-col>
      <v-col cols="12" class="mt-0 mb-0 ml-0 pt-0 pb-0 pl-0">
         <v-text-field
             label="Mobile"
             prepend-icon="mdi-cellphone-basic"
             v-model="currentItem.phone"
             dense
             outlined
         />
      </v-col>
      <v-col cols="12" class="mt-0 mb-0 ml-0 pt-0 pb-0 pl-0">
        <v-text-field
            class="right-align-text"
            prepend-icon="mdi-cash"
            label="Total Amount"
            type="number"
            :value="getTotal"
            dense
            outlined
            disabled
        />
      </v-col>
      <v-col cols="12" class="mt-0 mb-0 ml-0 pt-0 pb-0 pl-0">
        <v-file-input
            label="Attachment"
            prepend-icon="mdi-camera"
            accept="image/*"
            dense
            outlined
            @change.native="onChangeImageHandler"
            @click:clear="onClearHandler"
        />
        <span v-if="error.imageError" class="error-message">{{error.imageError}}</span>
        <v-img  v-if="fileUrl.imageUrl" :src="fileUrl.imageUrl" aspect-ratio="2" contain/>
      </v-col>
    </v-row>
  </v-form>
</base-popup>
</template>

<script>
import BasePopup from "./BasePopup";
import Popup from "../mixins/Popup";
import GPAutoComplete from "../GPAutoComplete";
export default {
  name: "ManualPaymentMergedPopup",
  mixins: [Popup],
  components: {
    GPAutoComplete,
    BasePopup
  },
  computed: {
     getTotal() {
       if(!this.currentItem.merged_invoice_details) return 0;

       return  Number.parseFloat(
           this.currentItem.merged_invoice_details.reduce((prev, item) => {
             return Number.parseFloat(prev + Number.parseFloat(item.invoice_details.totalAmount));
           }, 0)
       ).toFixed(2);
     }
  },
  methods: {
    manualPaymentHandler() {
      if (!this.isFormValid) {
        return;
      }

      if(typeof this.currentItem.paymentMethod === 'object') {
        this.currentItem.paymentMethod = this.currentItem.paymentMethod.id;
      }

      if(!this.currentItem.attachment) this.currentItem.attachment = '';

      this.$emit('saveItemHandler', {...this.currentItem});
      this.closePopupHandler();
    },
    getInvoiceNo() {
      if(!this.currentItem.merged_invoice_details) return '';

      let invoices = [];
      this.currentItem.merged_invoice_details.forEach((item) => {
         invoices.push(item.invoice_details.invoiceNo)
      })

      return invoices.toString();
    }
  }
}
</script>

<style scoped>

</style>